import {
  RECEIVE_ACCOUNT,
  ACCOUNT_ERROR,
  RECEIVE_ACCOUNT_SUMMARY,
  ACCOUNT_SUMMARY_ERROR,
  ACCOUNT_SUMMARY_LOADING,
  ACCOUNT_RECEIVE_USER_PROFILE,
  ACCOUNT_USER_PROFILE_ERROR,
  ACCOUNT_USER_PROFILE_PROCESSING,
  ACCOUNT_RECEIVE_BOOKING,
  ACCOUNT_BOOKING_ERROR,
  ACCOUNT_CLEAR_SUMMARY,
  UPCOMING_APPOINTMENTS_RECEIVED,
  UPCOMING_APPOINTMENTS_ERROR,
  UPCOMING_APPOINTMENT_RESCHEDULED,
  PAST_APPOINTMENTS_RECEIVED,
  PAST_APPOINTMENTS_ERROR,
  SET_APPOINTMENT_VIEW,
  UPCOMING_APPOINTMENT_CANCELLED,
  BOOKING_PAPERWORK_SKIPPED,
  BOOKING_PAYMENT_SKIPPED,
  GET_INSURANCE_FRONT_CARD_IMAGE_SUCCESS,
  GET_INSURANCE_FRONT_CARD_IMAGE_ERROR,
  GET_INSURANCE_BACK_CARD_IMAGE_SUCCESS,
  GET_INSURANCE_BACK_CARD_IMAGE_ERROR,
  BOOKING_TOKBOX_RATING_SUBMITTED,
  CREATE_VERIFIED_USER_PROFILE,
  RECEIVE_USER_PROFILE_SPECIALTY_PREFERENCES,
  RECEIVE_USER_PROFILE_APPOINTMENT_PREFERENCES,
  USER_PROFILE_SPECIALTY_PREFERENCES_ERROR,
  USER_PROFILE_APPOINTMENT_PREFERENCES_ERROR,
  FETCH_USER_PROFILE_SPECIALTY_PREFERENCES,
  FETCH_USER_PROFILE_APPOINTMENT_PREFERENCES,
  ACCOUNT_MARK_MESSAGES_READ,
  ACCOUNT_TRACK_INTERACTION,
} from '../constants';
import { analyticsLoginIdentify } from '../core/analytics';

const receiveAccount = value => ({
  type: RECEIVE_ACCOUNT,
  payload: { value },
});

const accountError = value => ({
  type: ACCOUNT_ERROR,
  payload: { value },
});

const receiveAccountSummary = value => {
  analyticsLoginIdentify(value);
  return {
    type: RECEIVE_ACCOUNT_SUMMARY,
    payload: { value },
  };
};

export const getInsuranceProfileImageFrontSuccess = value => ({
  type: GET_INSURANCE_FRONT_CARD_IMAGE_SUCCESS,
  payload: { value },
});

export const getInsuranceProfileImageBackSuccess = value => ({
  type: GET_INSURANCE_BACK_CARD_IMAGE_SUCCESS,
  payload: { value },
});

export const getInsuranceProfileImageFrontError = value => ({
  type: GET_INSURANCE_BACK_CARD_IMAGE_SUCCESS,
  payload: { value },
});

export const getInsuranceProfileImageBackError = value => ({
  type: GET_INSURANCE_BACK_CARD_IMAGE_ERROR,
  payload: { value },
});

const accountSummaryLoading = () => ({
  type: ACCOUNT_SUMMARY_LOADING,
});

const accountSummaryError = value => ({
  type: ACCOUNT_SUMMARY_ERROR,
  payload: { value },
});

const receiveUserProfileForAccount = value => ({
  type: ACCOUNT_RECEIVE_USER_PROFILE,
  payload: { value },
});

const userProfileProcessing = () => ({
  type: ACCOUNT_USER_PROFILE_PROCESSING,
});

const userProfileError = value => ({
  type: ACCOUNT_USER_PROFILE_ERROR,
  payload: { value },
});

const receiveBooking = value => ({
  type: ACCOUNT_RECEIVE_BOOKING,
  payload: { value },
});

const bookingError = value => ({
  type: ACCOUNT_BOOKING_ERROR,
  payload: { value },
});

const clearSummary = () => ({
  type: ACCOUNT_CLEAR_SUMMARY,
});

const upcomingAppointmentsReceived = value => ({
  type: UPCOMING_APPOINTMENTS_RECEIVED,
  payload: { value },
});

const upcomingAppointmentsError = value => ({
  type: UPCOMING_APPOINTMENTS_ERROR,
  payload: { value },
});

const upcomingAppointmentCancelled = value => ({
  type: UPCOMING_APPOINTMENT_CANCELLED,
  payload: { value },
});

const upcomingAppointmentRescheduled = value => ({
  type: UPCOMING_APPOINTMENT_RESCHEDULED,
  payload: { value },
});

const pastAppointmentsReceived = value => ({
  type: PAST_APPOINTMENTS_RECEIVED,
  payload: { value },
});

const pastAppointmentsError = value => ({
  type: PAST_APPOINTMENTS_ERROR,
  payload: { value },
});

const setAppointmentView = value => ({
  type: SET_APPOINTMENT_VIEW,
  payload: { value },
});

const setIsPaperworkSkipped = value => ({
  type: BOOKING_PAPERWORK_SKIPPED,
  payload: { value },
});

const setIsPaymentSkipped = value => ({
  type: BOOKING_PAYMENT_SKIPPED,
  payload: { value },
});

const setHasSubmittedTokboxRating = () => ({
  type: BOOKING_TOKBOX_RATING_SUBMITTED,
});

const createVerifiedUserProfile = value => ({
  type: CREATE_VERIFIED_USER_PROFILE,
  payload: { value },
});

const updateUserProfile = value => ({
  type: UPDATE_USER_PROFILE,
  payload: { value },
});

const fetchUserProfileSpecialtyPreferences = () => ({
  type: FETCH_USER_PROFILE_SPECIALTY_PREFERENCES,
});

const fetchUserProfileAppointmentPreferences = () => ({
  type: FETCH_USER_PROFILE_APPOINTMENT_PREFERENCES,
});

const receiveUserProfileSpecialtyPreferences = value => ({
  type: RECEIVE_USER_PROFILE_SPECIALTY_PREFERENCES,
  payload: { value },
});

const receiveUserProfileAppointmentPreferences = value => ({
  type: RECEIVE_USER_PROFILE_APPOINTMENT_PREFERENCES,
  payload: { value },
});

const userProfileSpecialtyPreferencesError = () => ({
  type: USER_PROFILE_SPECIALTY_PREFERENCES_ERROR,
});

const userProfileAppointmentPreferencesError = () => ({
  type: USER_PROFILE_APPOINTMENT_PREFERENCES_ERROR,
});

const accountMarkMessagesRead = () => ({
  type: ACCOUNT_MARK_MESSAGES_READ,
});

const accountTrackInteraction = value => ({
  type: ACCOUNT_TRACK_INTERACTION,
  payload: { value },
});

export {
  receiveAccount,
  accountError,
  receiveAccountSummary,
  accountSummaryError,
  accountSummaryLoading,
  receiveUserProfileForAccount,
  userProfileError,
  userProfileProcessing,
  receiveBooking,
  bookingError,
  clearSummary,
  upcomingAppointmentsReceived,
  upcomingAppointmentRescheduled,
  upcomingAppointmentCancelled,
  upcomingAppointmentsError,
  pastAppointmentsReceived,
  pastAppointmentsError,
  setAppointmentView,
  setIsPaperworkSkipped,
  setIsPaymentSkipped,
  setHasSubmittedTokboxRating,
  createVerifiedUserProfile,
  updateUserProfile,
  receiveUserProfileSpecialtyPreferences,
  receiveUserProfileAppointmentPreferences,
  userProfileSpecialtyPreferencesError,
  userProfileAppointmentPreferencesError,
  fetchUserProfileSpecialtyPreferences,
  fetchUserProfileAppointmentPreferences,
  accountMarkMessagesRead,
  accountTrackInteraction,
};
